export default {
	$window: $(window),
	$document: $(document),
	$html: $(document.documentElement),
	$body: $(document.body),

	$headerBackHome: $('.header__back-home'),
	$footer: $('.footer'),
	$footerShare: $('.footer__share'),
	$footerInfo: $('.footer__info'),
	$footerArticle: $('.footer__article'),

	$home: $('.home'),
	$article: $('.article'),

	$hashCarousel: $('.home__hash-carousel'),
	$hashItem: $('.home__hash-list__item'),
	$hashArea: $('.home__hash-circle'),
	$hashRead: $('.home__hash-read'),

	$nav: $('.nav__container'),
	$navBtn: $('.nav__btn'),
	$navClose: $('.nav__close'),
	$navDown: $('.nav__down'),
	$navList: $('.nav__list'),
	$navLink: $('.nav__list ul a'),

	$similar: $('.article__similar__container'),

	$bg: $('.home__bg'),
};
